const ButtonType = {
    Action: 0,
    Nav: 1,
    Popup: 2,
}

export default ButtonType